<template>
  <div id="rekam_medis_klinik">
    <Header />
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <span style="margin-left:1.5em">Informasi bertanda  <label style="color:red"> *</label> wajib diisi</span>
          <div class="accordion mb-3">
            <b-card no-body class="card-box" id="box_subjective" ref="box_subjective">
              <b-card-header>
                <b-button
                  class="btn-link btn-lg btn-block d-flex align-items-center justify-content-between shadow-none"
                  v-b-toggle.accordion_subjective
                >
                  <span>SUBJECTIVE<label style="color:red">*</label></span>
                  <font-awesome-icon icon="angle-up" class="font-size-xl" />
                </b-button>
              </b-card-header>
              <b-collapse id="accordion_subjective" accordion="accordion_parent" role="tabpanel">
                <b-card-body class="mr-4 accordion accordion-child" role="tablist">
                  <b-card no-body id="box_subjective_anamnesa" ref="box_subjective_anamnesa" class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle.subjective_anamnesa
                        id="btn_subjective_anamnesa"
                        class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                      >
                        <span>Keluhan & Anamnesa<label style="color:red">*</label></span>
                        <font-awesome-icon icon="angle-up" class="font-size-xl" />
                      </b-button>
                    </b-card-header>
                    <b-collapse id="subjective_anamnesa" accordion="subjective_child" role="tabpanel">
                      <b-card-body>
                        <SubjectiveAnamnesa />
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body id="box_subjective_riwayat" ref="box_subjective_riwayat" class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle.subjective_riwayat
                        id="btn_subjective_riwayat"
                        class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                      >
                        <span class="mb-2">Riwayat Alergi{{ saving_params.is_poli_gigi ? ', Kesehatan' : '' }} & Kondisi Khusus<label style="color:red" v-if="pcareVersion == '1'">*</label></span>
                        <font-awesome-icon icon="angle-up" class="font-size-xl" />
                      </b-button>
                    </b-card-header>
                    <b-collapse id="subjective_riwayat" accordion="subjective_child" role="tabpanel">
                      <b-card-body>
                        <SubjectiveRiwayat
                          :pcareVersion="pcareVersion"
                          :ketPenyakitLainErr="rekamMedisError.ket_penyakit_lainnya"
                          @ket-penyakit-lain-err="updateKetPenyakitLainErr"
                          @update-post-data="updatePostDataRiwayat"
                        />
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-card-body>
              </b-collapse>
            </b-card>
            
            <b-card no-body class="card-box" id="box_objective" ref="box_objective">
              <b-card-header>
                <b-button
                  class="btn-link btn-lg btn-block d-flex align-items-center justify-content-between shadow-none"
                  v-b-toggle.accordion_objective
                >
                  <span>OBJECTIVE<label style="color:red" v-if="saving_params.is_bpjs">*</label></span>
                  <font-awesome-icon icon="angle-up" class="font-size-xl" />
                </b-button>
              </b-card-header>
              <b-collapse id="accordion_objective" accordion="accordion_parent" role="tabpanel">
                <b-card-body no-body class="mr-4 accordion accordion-child" role="tablist">
                  <b-card no-body id="box_objective_tandavital" ref="box_objective_tandavital" class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle.objective_tandavital
                        id="btn_objective_tandavital"
                        class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                      >
                        <span>Tanda - Tanda Vital<label v-if="saving_params.is_bpjs" style="color:red">*</label></span>
                        <font-awesome-icon icon="angle-up" class="font-size-xl" />
                      </b-button>
                    </b-card-header>
                    <b-collapse id="objective_tandavital" accordion="objective_child" role="tabpanel">
                      <b-card-body>
                        <ObjectiveTandaVital />
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body id="box_objective_pemeriksaan_fisik" ref="box_objective_pemeriksaan_fisik" class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle.objective_pemeriksaan_fisik
                        id="btn_objective_pemeriksaan_fisik"
                        class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                      >
                        <span>Pemeriksaan Fisik<label v-if="saving_params.is_bpjs" style="color:red">*</label></span>
                        <font-awesome-icon icon="angle-up" class="font-size-xl" />
                      </b-button>
                    </b-card-header>
                    <b-collapse id="objective_pemeriksaan_fisik" accordion="objective_child" role="tabpanel">
                      <b-card-body>
                        <ObjectivePemeriksaan
                          ref="pemeriksaan"
                          :pemeriksaanFisikErr="rekamMedisError.pemeriksaan_fisik"
                          @formBasicDataChange="handleChangePemeriksaanFisik"
                        />
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body id="box_objective_odontogram" ref="box_objective_odontogram" class="mb-1 shadow-none" v-if="saving_params.is_poli_gigi">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle.objective_odontogram
                        id="btn_objective_odontogram"
                        class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                      >
                        <span>Odontogram</span>
                        <font-awesome-icon icon="angle-up" class="font-size-xl" />
                      </b-button>
                    </b-card-header>
                    <b-collapse id="objective_odontogram" accordion="objective_child" role="tabpanel">
                      <b-card-body>
                        <ObjectiveOdontogram
                          ref="odontogram"
                          @icdxOdontogramCheck="checkICDXOdontogram"
                          :ohisErr="rekamMedisError.ohis"
                        />
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body id="box_objective_pemeriksaan_penunjang" ref="box_objective_pemeriksaan_penunjang" class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle.objective_pemeriksaan_penunjang
                        id="btn_objective_pemeriksaan_penunjang"
                        class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                      >
                        <span>Pemeriksaan Penunjang</span>
                        <font-awesome-icon icon="angle-up" class="font-size-xl" />
                      </b-button>
                    </b-card-header>
                    <b-collapse id="objective_pemeriksaan_penunjang" accordion="objective_child" role="tabpanel">
                      <b-card-body>
                        <ObjectivePemeriksaanPenunjang ref="pemeriksaan-penunjang" />
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="card-box" id="box_assessment" ref="box_assessment">
              <b-card-header>
                <b-button
                  class="btn-link btn-lg btn-block d-flex align-items-center justify-content-between shadow-none"
                  v-b-toggle.accordion_assessment
                >
                  <span>ASSESSMENT<label style="color:red" v-if="!icdxOodontogram || pcareVersion == '1'">*</label></span>
                  <font-awesome-icon icon="angle-up" class="font-size-xl" />
                </b-button>
              </b-card-header>
              <b-collapse id="accordion_assessment" accordion="accordion_parent" role="tabpanel">
                <b-card-body class="mr-4 accordion accordion-child" role="tablist">
                  <b-card no-body id="box_assessment_diagnosa" ref="box_assessment_diagnosa" class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle.assessment_diagnosa
                        id="btn_assessment_diagnosa"
                        class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                      >
                        <span>Diagnosa{{ pcareVersion == '1' ? ' & Prognosa' : '' }}<label style="color:red" v-if="!icdxOodontogram || pcareVersion == '1'">*</label></span>
                        <font-awesome-icon icon="angle-up" class="font-size-xl" />
                      </b-button>
                    </b-card-header>
                    <b-collapse id="assessment_diagnosa" accordion="assessment_child" role="tabpanel">
                      <b-card-body>
                        <AssessmentDiagnosa ref="diagnosa" :icdxOodontogram="icdxOodontogram" :pcareVersion="pcareVersion" />
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="card-box" id="box_plan" ref="box_plan">
              <b-card-header>
                <b-button
                  class="btn-link btn-lg btn-block d-flex align-items-center justify-content-between shadow-none"
                  v-b-toggle.accordion_plan
                >
                  <span>PLAN<label style="color:red" v-if="saving_params.is_bpjs">*</label></span>
                  <font-awesome-icon icon="angle-up" class="font-size-xl" />
                </b-button>
              </b-card-header>
              <b-collapse id="accordion_plan" accordion="accordion_parent" role="tabpanel">
                <b-card-body class="mr-4 accordion accordion-child" role="tablist">
                  <b-card no-body id="box_plan_tatalaksana" ref="box_plan_tatalaksana" class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle.plan_tatalaksana
                        id="btn_plan_tatalaksana"
                        class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                      >
                        <span>Tata Laksana<label style="color:red" v-if="saving_params.is_bpjs">*</label></span>
                        <font-awesome-icon icon="angle-up" class="font-size-xl" />
                      </b-button>
                    </b-card-header>
                    <b-collapse id="plan_tatalaksana" accordion="plan_child" role="tabpanel">
                      <b-card-body>
                        <PlanTataLaksana
                          v-if="postDataLoaded"
                          :initial-data="{
                            terapiObat: postData.terapi_obat,
                            terapiNonObat: postData.terapi_non_obat,
                            bmhp: postData.bmhp,
                            pcareVersion: pcareVersion,
                          }"
                          :terapi-obat-touched="terapiObatTouched"
                          @update-terapi-obat-touched="updateTerapiObatTouched"
                          :terapi-non-obat-touched="terapiNonObatTouched"
                          @update-terapi-non-obat-touched="updateTerapiNonObatTouched"
                          :post-data-updated="postDataUpdated"
                          ref="tata-laksana"
                        />
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <PlanSuratPenunjang />
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>

          <Footer ref="footer"  @icdxRujukanCheck="checkIcdxRujukan" />
          <div class="row">
            <div class="col-sm-6" v-if="surveyKepuasan && satusehatAuthValid">
              <label class="">QR Code Survey Kepuasan Pelanggan</label>
            </div>
            <div :class="surveyKepuasan && satusehatAuthValid ? 'col-sm-6 d-flex justify-content-xl-end' : 'col-sm-12 d-flex justify-content-xl-end'">
              <b-form-checkbox
                v-model="consultation"
                class="text-center m-2"
                :disabled="disabledConsultation"
              >
                <label class="font-weight-bold">Konsultasi Selesai</label>
              </b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6" v-if="surveyKepuasan && satusehatAuthValid">
              <button type="button" class="btn btn-primary mr-3" @click.prevent="donwloadImage(surveyKepuasan)">
                Download
              </button>
              <button type="button" class="btn btn-show" @click.prevent="readFile(surveyKepuasan)">
                Show
              </button>
            </div>
            <div :class="surveyKepuasan && satusehatAuthValid ? 'col-sm-6 d-flex justify-content-xl-end' : 'col-sm-12 d-flex justify-content-xl-end'">
              <button @click="exitButton()" class="btn btn-info m-2">Keluar</button>
              <button @click="saveButton()" class="btn btn-primary m-2 btn-spinner">
                <b-spinner v-show="saving_params.is_saving" class="btn-wrapper--icon" small></b-spinner>
                <span class="btn-wrapper--label">Simpan</span>
              </button>
            </div>
          </div>
          <vue-internet-checker
            @status="statusInet"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faPenAlt,
  faKeyboard,
  faEraser,
  faAngleUp,
  faCamera,
  faFolder,
  faDownload,
  faEye,
  faTrash,
  faPen,
  faRedo,
  faInfo,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faPenAlt,
  faKeyboard,
  faEraser,
  faAngleUp,
  faCamera,
  faFolder,
  faDownload,
  faEye,
  faTrash,
  faPen,
  faRedo,
  farCircle,
  faInfo,
  faTrashAlt,
);

import { mapGetters, mapActions } from 'vuex';
import router from '@/router';
import startCase from 'lodash/startCase';
import moment from 'moment';
moment.locale('id');
import rekamMedisMixin from './mixins';

export default {
  name: 'RekamMedis',
  mixins: [rekamMedisMixin],
  data: () => {
    return {
      beingSubmit: false,
      consultation: false,
      rmId: localStorage.getItem('rekam_medis_id'),
      ediRekamMedis: {},
      disabledConsultation: false,
      isOnline: true,
      formBasicData: null,
      icdxOodontogram: false,
      terapiObatTouched: false,
      terapiNonObatTouched: false,
      pcareVersion: null,
      icdxDiagnosaCheck: false,
      rekamMedisError: {
        ket_penyakit_lainnya: false,
        pemeriksaan_fisik: [],
        ohis: {
          debris: [],
          kalkulus: [],
        },
      },
      postDataUpdated: null,
      elZoom: 'zoom: 100%;',
      surveyKepuasan: null,
      ohis: {
        debris: [
          'debris_index_16',
          'debris_index_11',
          'debris_index_26',
          'debris_index_36',
          'debris_index_31',
          'debris_index_46',
        ],
        kalkulus: [
          'kalkulus_index_16',
          'kalkulus_index_11',
          'kalkulus_index_26',
          'kalkulus_index_36',
          'kalkulus_index_31',
          'kalkulus_index_46',
        ],
      },
    }
  },
  components: {
    Header: () => import('./RekamMedis/Header.vue'),
    SubjectiveAnamnesa: () => import('./RekamMedis/SubjectiveAnamnesa.vue'),
    SubjectiveRiwayat: () => import('./RekamMedis/SubjectiveRiwayat.vue'),
    ObjectiveTandaVital: () => import('./RekamMedis/ObjectiveTandaVital.vue'),
    ObjectivePemeriksaan: () => import('./RekamMedis/ObjectivePemeriksaan.vue'),
    ObjectiveOdontogram: () => import('./RekamMedis/ObjectiveOdontogram.vue'),
    ObjectivePemeriksaanPenunjang: () => import('./RekamMedis/ObjectivePemeriksaanPenunjang.vue'),
    AssessmentDiagnosa: () => import('./RekamMedis/AssessmentDiagnosa.vue'),
    PlanTataLaksana: () => import('./RekamMedis/PlanTataLaksana.vue'),
    PlanSuratPenunjang: () => import('../../components/SuratPenunjang/Index.vue'),
    Footer: () => import('./RekamMedis/Footer.vue'),
    vueInternetChecker: () => import('vue-internet-checker'),
  },
  beforeRouteLeave(to, from, next) {
    if (
        !this.beingSubmit && localStorage.getItem('IDLE') != 1
        && to.name != 'klinik-rekam-medis-riwayat'
        && to.name != 'klinik-subskripsi'
        && to.name != 'home'
      ) {
      this.$swal({
        title: startCase('keluar'),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: startCase('tidak'),
        confirmButtonText: startCase('ya')
      }).then(res => {
        if (res.value) {
          this.updateStatusIfLeave()
          next();
        } else {
          next(false);
        }
      });
    } else {
      if(to.name != 'klinik-rekam-medis-riwayat') this.updateStatusIfLeave()
      next();
    }
  },
  mounted() {
    if(localStorage.getItem('edit_rm') == '1'){
      Promise.all([
        this.cekPaketNolock()
      ]);
    }else{
      Promise.all([
        this.cekPaket()
      ]);
    }
    this.setParamsData()
    this.setCloseMR();
  },
  watch: {
    consultation() {
      this.updateSavingParams({
        key: 'is_selesai',
        value: this.consultation ? true : false
      });
      this.updatePostDataKlinik([{
        key: 'selesai',
        value: this.consultation ? 1 : 0
      }])
    },
    'saving_params.is_bpjs'() {
      if (this.bpjsAuthValid && this.bpjsConfig.pcare_version == '1' && this.saving_params.is_bpjs) this.pcareVersion = this.bpjsConfig.pcare_version;
    },
  },
  computed: {
    ...mapGetters([
      'pasien', 'saving_params',
      'postData', 'getKlinikId',
      'error_sync_msg', 'getRolesName',
      'postDataLoaded', 'bpjsAuthValid',
      'bpjsConfig', 'satusehatAuthValid',
    ])
  },
  created() {
    this.fetchData(this.getKlinikId);
    this.fetchDataSurveyKepuasan();
    this.ediRekamMedis = localStorage.getItem('edit_rekam_medis')
    if(this.ediRekamMedis != null && this.ediRekamMedis != 'null') {
      const rm = JSON.parse(this.ediRekamMedis)
      if(rm.transklinik.status == 'SELESAI') {
        this.disabledConsultation = true
        this.consultation = true
      } else {        
        this.disabledConsultation = false
        this.consultation = false
      }
    }
  },
  methods: {
    async statusInet(ele) {
      this.isOnline = ele
    },
    setCloseMR(){
      localStorage.setItem('ALLOW_BACK_MR_TAB', 0);
    },
    // import the action from VUEX
    ...mapActions([
      'fetchData', 'saveRekamMedis',
      'updatePostDataKlinik', 'updateSavingParams',
      'updatePostData'
    ]),
    async saveButton() {
      this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false
      });

      return this.$swal({
        title: 'Simpan data rekam medis pasien?',
        showCancelButton: true,
        confirmButtonText: 'Simpan',
        cancelButtonText: 'Batal',
        reverseButtons: true,
        type: 'warning'
      }).then(async result => {
        if (result.value) {

          if (!this.validate()) {
            return this.handleError('Silakan lengkapi data Anda!');
          }

          if (!this.saving_params.is_next_konsul) {
            return this.handleError('Anda belum memilih durasi konsultasi!');
          }

          if (!this.saving_params.is_email_format) {
            return this.handleError('Silakan lengkapi Email Pengingat!');

          }

          if (!this.saving_params.is_number) {
            return this.handleError('No. Handphone wajib diisi!');
          }
          
          if (!this.saving_params.is_reminder) {
            return this.handleError('Pilih Reminder wajib diisi!');
          }

          try {
            await this.saveRekamMedis(true);
          } catch(err) {
            if (this.isOnline) {
              this.$swal({
                title: 'Oops...',
                text: 'Gagal memuat data, terjadi gangguan sistem.',
                type: 'error',
                confirmButtonText: 'OK'
              });
            } else {
              this.$swal({
                title: 'Oops...',
                text: 'Gagal memuat data, periksa koneksi Anda kembali.',
                type: 'error',
                showCancelButton: true,
                cancelButtonText: 'Batal',
                confirmButtonText: 'Coba Lagi'
              }).then(async res => {
                if (res.value) {
                  await this.saveRekamMedis(true);
                }
              });
            }
          }

          if (!this.saving_params.is_saved) {
            this.validate();
            return this.handleError('Penyimpanan Rekam Medis gagal!');
          }

          if (!this.saving_params.is_kuotanotnull) {
            let isPic = this.getRolesName.includes('pic_cabang');
            return this.$swal({
                type: 'warning',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false,
                text: 'Paket klinik telah habis! Akses menu akan kembali dibuka setelah paket diperpanjang. Silakan hubung PIC Faskes Anda.'
            }).then(val => {
                if(isPic) {
                  this.$router.push('/klinik/subskripsi');
                }else{
                  this.$router.push('/');
                }
            })
          }
          this.beingSubmit = true;
          
          if(this.consultation) {
            if (this.error_sync_msg) {
              const message = `
                <p>Untuk melakukan perubahan, klik ‘Edit Rekam Medis’ pada action di list antrean sesuai nama pasien.</p>
                ${this.error_sync_msg}
              `
              this.$swal({
                title: `Data Berhasil disimpan`,
                html: message,
                type: 'success',
                confirmButtonText: 'Lanjutkan',
                confirmButtonColor: '#1bc943',
                allowOutsideClick: false
              }).then(res => {
                  router.push({
                  name: 'antrean-klinik-list',
                });
              });
              return;
            }

            this.$swal
            .fire(
              'Data berhasil di simpan!',
              'Untuk melakukan perubahan, klik ‘Edit Rekam Medis’ pada action di list antrean sesuai nama pasien.',
              'success'
            )
            .then(res => {
              router.push({
                name: "antrean-klinik-list",
              });
            });
          } else {
            this.updateSavingParams('setIsSaving', { key: 'is_saving', value: false });
            localStorage.setItem("rm_reload", true);
            
            if (this.error_sync_msg) {
              const message = `
                <p>Untuk melakukan perubahan, klik ‘Edit Rekam Medis’ pada action di list antrean sesuai nama pasien.</p>
                ${this.error_sync_msg}
              `
              this.$swal({
                title: `Data Berhasil disimpan`,
                html: message,
                type: "success",
                allowOutsideClick: false
              }).then(res => {
                window.location.reload()
              });
              return;
            }
            
            this.$swal({
              type: 'success',
              text: 'Data berhasil disimpan!'
            })
            .then(res => {
              window.location.reload()
            })
          }
        }
      });
    },
    handleError(message) {
      return this.$swal({
        type: 'error',
        title: 'Oops...',
        text: message
      });
    },
    exitButton() {
      return this.$swal({
        html: 'Apakah Anda yakin untuk keluar?<br>Data yang telah ditulis tidak akan tersimpan.',
        title: 'Keluar',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
        type: 'warning'
      }).then(res => {
        if (res.value) {
          this.beingSubmit = true;
          router.push({ path: '/antrean-klinik', query: { tab: 'today' } });
        }
      });
    },
    resetErrorRekamMedis() {
      // subjective
      document.getElementById('btn_subjective_anamnesa').classList.remove('bottom-invalid');
      
      const editorAnamnesa = document.getElementById('editor_anamnesa');
      editorAnamnesa.getElementsByClassName('ql-container')[0].style.removeProperty('border');
      editorAnamnesa.getElementsByClassName('ql-container')[0].style.removeProperty('border-top');
      editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.removeProperty('border');
      editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.removeProperty('border-bottom');
      
      this.$refs['box_subjective'].classList.remove('invalid');
      this.$refs['box_subjective'].classList.remove('bottom-invalid');

      // objective
      if (this.saving_params.is_bpjs) {
        document.getElementById('btn_subjective_riwayat').classList.remove('bottom-invalid');
        document.getElementById('kesadaran').classList.remove('select-invalid');
      }
      document.getElementById('btn_objective_tandavital').classList.remove('bottom-invalid');
      document.getElementById('btn_objective_pemeriksaan_fisik').classList.remove('bottom-invalid');
      if (this.saving_params.is_poli_gigi) {
        this.ohis.debris.forEach(k => {
          document.getElementById(k).classList.remove('invalid');
        });
        this.ohis.kalkulus.forEach(k => {
          document.getElementById(k).classList.remove('invalid');
        });
        document.getElementById('btn_objective_odontogram').classList.remove('bottom-invalid');
      }
      this.$refs['box_objective'].classList.remove('invalid');
      this.$refs['box_objective'].classList.remove('bottom-invalid');

      // assessment
      if (this.pcareVersion == '1') {
        document.getElementById('prognosa').classList.remove('select-invalid');
      }
      document.getElementById('dgKodePenyakit').getElementsByClassName('multiselect__tags')[0].style.removeProperty('border');
      document.getElementById('dgNamaPenyakit').getElementsByClassName('multiselect__tags')[0].style.removeProperty('border');
      document.getElementById('btn_assessment_diagnosa').classList.remove('bottom-invalid');
      this.$refs['box_assessment'].classList.remove('invalid');
      this.$refs['box_assessment'].classList.remove('bottom-invalid');

      // plan
      this.$refs['box_plan'].classList.remove('invalid');
      this.$refs['box_plan'].classList.remove('bottom-invalid');

      this.rekamMedisError.ket_penyakit_lainnya = false;
      this.rekamMedisError.pemeriksaan_fisik = [];
      this.rekamMedisError.ohis = {debris: [], kalkulus: []};
      this.terapiObatTouched = false;
      this.terapiNonObatTouched = false;
    },
    validate() {
      // only validate two field
      let result = [];
      this.resetErrorRekamMedis();

      // subjective
      let subjectiveErr = [], anamnesaErr = [];
      if (!this.checkValueData(this.postData.anamnesa_text)) {
        subjectiveErr.push('anamnesa_text');
        anamnesaErr.push('anamnesa_text');
      } else {
        const strippedContent = this.postData.anamnesa_text ? this.postData.anamnesa_text.replace(/<[^>]*>?/gm, '').trim() : "";
        if (this.saving_params.is_bpjs && (strippedContent.length < 10 || strippedContent.length > 255)) anamnesaErr.push('anamnesa_text');
      }
      if (this.saving_params.is_poli_gigi) {
        if (this.checkValueData(this.postData['penyakit_lainnya']) && this.postData['penyakit_lainnya'] == 'Y' && !this.checkValueData(this.postData['ket_penyakit_lainnya'])) {
          subjectiveErr.push('riwayat_kesehatan');
          this.rekamMedisError.ket_penyakit_lainnya = true;
        }
      }
      if (this.pcareVersion == '1') {
        ['riwayat_alergi_obat','riwayat_alergi_makanan'].forEach(k => {
          if (!this.checkValueData(this.postData[k]) || !this.checkValueData(this.postData[`${k.replace('riwayat_','')}_bpjs`])) {
            subjectiveErr.push('riwayat');
          } else {
            let val = this.postData[k];
            if (this.checkValueData(val) && val.toLowerCase().includes('lain') && !this.checkValueData(this.postData[`ket_${k}`])) {
              subjectiveErr.push('riwayat');
            }
          }
        });
        if (!this.checkValueData(this.postData['riwayat_alergi_udara']) || !this.checkValueData(this.postData['alergi_udara_bpjs'])) {
          subjectiveErr.push('riwayat');
        }
      }

      if (subjectiveErr.length > 0) {
        if (subjectiveErr.includes('anamnesa_text')) {
          const editorAnamnesa = document.getElementById('editor_anamnesa');
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.setProperty('border', '1px solid red');
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.setProperty('border-top', '1px solid #ccc');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.setProperty('border', '1px solid red');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.setProperty('border-bottom', '1px solid #ccc');
        }

        if (subjectiveErr.includes('anamnesa_text')) {
          document.getElementById('btn_subjective_anamnesa').classList.add('bottom-invalid');
          document.getElementById('subjective_anamnesa').style.setProperty('display', 'block');
          this.$root.$emit('bv::toggle::collapse', 'subjective_anamnesa');
        }

        if (subjectiveErr.includes('riwayat') || subjectiveErr.includes('riwayat_kesehatan')) {
          document.getElementById('btn_subjective_riwayat').classList.add('bottom-invalid');
          if (anamnesaErr.length < 1) {
            document.getElementById('subjective_riwayat').style.setProperty('display', 'block');
            this.$root.$emit('bv::toggle::collapse', 'subjective_riwayat');
          }
        }

        result.push(false);
        this.$refs['box_subjective'].classList.add('invalid');
        this.$refs['box_subjective'].classList.add('bottom-invalid');
        this.$root.$emit('bv::toggle::collapse', 'accordion_subjective');
      }

      // objective
      let objectiveErr = [], errorTandaVital = [], errorOHISDebris = [], errorOHISKalkulus = [];
      if (this.saving_params.is_bpjs) {
        ['tinggi_badan','berat_badan','tensi_sistole','tensi_diastole','nadi','respirasi','suhu','lingkar_perut','imt'].forEach((i) => {
          document.getElementById(i).classList.remove('invalid');
          if (i == 'tinggi_badan' && (this.postData[i] < 30 || this.postData[i] > 210)) errorTandaVital.push(i);
          if (i == 'berat_badan' && (this.postData[i] < 2 || this.postData[i] > 300)) errorTandaVital.push(i);
          if (i == 'tensi_sistole' && (this.postData[i] < 40 || this.postData[i] > 250)) errorTandaVital.push(i);
          if (i == 'tensi_diastole' && (this.postData[i] < 30  || this.postData[i] > 180)) errorTandaVital.push(i);
          if (i == 'nadi' && (this.postData[i] < 30 || this.postData[i] > 160)) errorTandaVital.push(i);
          if (i == 'respirasi' && (this.postData[i] < 5 || this.postData[i] > 70 )) errorTandaVital.push(i);
          if (!this.checkValueData(this.postData[i])) errorTandaVital.push(i);
        });

        if (errorTandaVital.length > 0) objectiveErr.push('tandavital');
        if (!this.checkValueData(this.postData.kdSadar)) objectiveErr.push('kesadaran');
      }
      if (this.saving_params.is_poli_gigi) {
        this.ohis.debris.forEach(d => {
          if (parseInt(this.postData[d]) > 3 || parseInt(this.postData[d]) < 1) {
            document.getElementById(d).classList.add('invalid');
            errorOHISDebris.push(`${d}_over_limit`);
          }
        });
        this.ohis.kalkulus.forEach(k => {
          if (parseInt(this.postData[k]) > 3 || parseInt(this.postData[k]) < 1) {
            document.getElementById(k).classList.add('invalid');
            errorOHISKalkulus.push(`${k}_over_limit`);
          }
        });
        if (errorOHISDebris.length > 0 || errorOHISKalkulus.length > 0) {
          this.rekamMedisError.ohis.debris = errorOHISDebris;
          this.rekamMedisError.ohis.kalkulus = errorOHISKalkulus;
          objectiveErr.push('ohis');
        }
      }

      // check jenis pemeriksaan penunjang
      if (this.postData.jenis_pemeriksaan && this.postData.jenis_pemeriksaan.length > 0) {
        this.postData.jenis_pemeriksaan.map(item => {
          if(item.selectedJenis && item.selectedJenis.value == 'radiologiFoto') {
            if (item.hasil == null || item.hasil == '') {
              objectiveErr.push('radiologiFoto')
            }
          }
        })
      }

      if (this.checkPemeriksaanFisik()) objectiveErr.push('pemeriksaan_fisik');

      if (objectiveErr.length > 0) {
        if (objectiveErr.includes('tandavital')) {
          errorTandaVital.forEach((i) => {
            document.getElementById(i).classList.add('invalid');
          });
          document.getElementById('objective_tandavital').style.setProperty('display', 'block');
          document.getElementById('btn_objective_tandavital').classList.add('bottom-invalid');
        }
        if (objectiveErr.includes('kesadaran') || objectiveErr.includes('pemeriksaan_fisik')) {
          if (objectiveErr.includes('kesadaran')) document.getElementById('kesadaran').classList.add('select-invalid');
          document.getElementById('objective_pemeriksaan_fisik').style.setProperty('display', 'block');
          document.getElementById('btn_objective_pemeriksaan_fisik').classList.add('bottom-invalid');
        }
        if (objectiveErr.includes('ohis')) {
          document.getElementById('objective_odontogram').style.setProperty('display', 'block');
          document.getElementById('btn_objective_odontogram').classList.add('bottom-invalid');
        }
        if (objectiveErr.includes('radiologiFoto')) {
          document.getElementById('upload-box-jenis').classList.add('invalid');
          document.getElementById('objective_pemeriksaan_penunjang').style.setProperty('display', 'block');
          document.getElementById('btn_objective_pemeriksaan_penunjang').classList.add('bottom-invalid');
        }

        result.push(false);
        this.$refs['box_objective'].classList.add('invalid');
        this.$refs['box_objective'].classList.add('bottom-invalid');
        this.$root.$emit('bv::toggle::collapse', 'accordion_objective');
      }

      // assessment
      let assessmentErr = []
      if (this.pcareVersion == '1' && !this.checkValueData(this.postData.kd_prognosa)) assessmentErr.push('prognosa');
      
      if (!this.icdxOodontogram) {
        if (!this.postData.kode_penyakit_primary) assessmentErr.push('kode_penyakit_primary');
        else if (!this.postData.kode_penyakit_primary && !this.saving_params.is_poli_gigi) assessmentErr.push('kode_penyakit_primary');
      }

      if (assessmentErr.length > 0) {
        if (assessmentErr.includes('kode_penyakit_primary')) {
          document.getElementById('dgKodePenyakit').getElementsByClassName('multiselect__tags')[0].style.setProperty('border', '1px solid red');
          document.getElementById('dgNamaPenyakit').getElementsByClassName('multiselect__tags')[0].style.setProperty('border', '1px solid red');
          document.getElementById('assessment_diagnosa').style.setProperty('display', 'block');
        }
        if (assessmentErr.includes('prognosa')) {
          document.getElementById('prognosa').classList.add('select-invalid');
          document.getElementById('assessment_diagnosa').style.setProperty('display', 'block');
        }

        result.push(false);
        this.$refs['box_assessment'].classList.add('invalid');
        this.$refs['box_assessment'].classList.add('bottom-invalid');
        document.getElementById('btn_assessment_diagnosa').classList.add('bottom-invalid');
        this.$root.$emit('bv::toggle::collapse', 'accordion_assessment');
      }

      // plan
      let planErr = [];
      if (
        this.postData.tatalaksana
        && this.postData.tatalaksana.length > 0
        && this.postData.lunas == false
        && this.saving_params.is_selesai
      ) {
        let check = this.postData.tatalaksana.find(t => t.stok != null && (t.stok < t.quantity || t.stok == 0) && ['obat', 'bahan habis pakai'].includes(t.kategori_layanan.toLowerCase()));
        if (this.checkValueData(check)) planErr.push('tatalaksana');
      }

      if (this.saving_params.is_bpjs) {
        if (
          !this.checkValueData(this.postData.terapi_obat)
          || (this.checkValueData(this.postData.terapi_obat) && this.postData.terapi_obat.trim().length < 4)
          || (this.checkValueData(this.postData.terapi_obat) && this.postData.terapi_obat.length > 255)
        ) {
          planErr.push('terapi_obat');
        }

        if (
          !this.checkValueData(this.postData.terapi_non_obat)
          || (this.checkValueData(this.postData.terapi_non_obat) && this.postData.terapi_non_obat.trim().length < 4)
          || (this.checkValueData(this.postData.terapi_non_obat) && this.postData.terapi_non_obat.length > 255)
        ) {
          planErr.push('terapi_non_obat');
        }
      }
      
      if (planErr.length > 0) {
        if (planErr.includes('terapi_obat')) this.terapiObatTouched = true;
        if (planErr.includes('terapi_non_obat')) this.terapiNonObatTouched = true;

        result.push(false);
        document.getElementById('plan_tatalaksana').style.setProperty('display', 'block');
        this.$root.$emit('bv::toggle::collapse', 'accordion_plan');
        this.$refs['box_plan'].classList.add('invalid');
        this.$refs['box_plan'].classList.add('bottom-invalid');
      }

      // footer
      if (this.saving_params.is_bpjs) {
        if (this.postData.kdStatusPulang == undefined || this.postData.kdStatusPulang == null || this.postData.kdStatusPulang == '') {
          const parent = document.getElementById('status_pulang')
          parent.getElementsByClassName('vs__dropdown-toggle')[0].style.setProperty('border-color', 'red');
          result.push(false);
        } else {
          const parent = document.getElementById('status_pulang')
          parent.getElementsByClassName('vs__dropdown-toggle')[0].style.removeProperty('border-color');
        }
      }
      return result.length == 0;
    },
    updateKetPenyakitLainErr(val) {
      this.rekamMedisError.ket_penyakit_lainnya = val;
    },
    handleChangePemeriksaanFisik(data) {
      this.formBasicData = data;
      this.rekamMedisError.pemeriksaan_fisik = this.rekamMedisError.pemeriksaan_fisik;
    },
    checkICDXOdontogram(val) {
      this.icdxOodontogram = val;

      if (this.icdxOodontogram) {
        document.getElementById('dgKodePenyakit').getElementsByClassName('multiselect__tags')[0].style.removeProperty('border');
        document.getElementById('dgNamaPenyakit').getElementsByClassName('multiselect__tags')[0].style.removeProperty('border');
        this.$refs['box_assessment'].classList.remove('invalid');
        this.$refs['box_assessment'].classList.remove('bottom-invalid');
        document.getElementById('btn_assessment_diagnosa').classList.remove('bottom-invalid');
      }
    },
    checkIcdxRujukan(val) {
      this.icdxDiagnosaCheck = val;

      if (!this.icdxDiagnosaCheck) {
        document.getElementById('dgKodePenyakit').getElementsByClassName('multiselect__tags')[0].style.setProperty('border', '1px solid red');
        document.getElementById('dgNamaPenyakit').getElementsByClassName('multiselect__tags')[0].style.setProperty('border', '1px solid red');
        this.$refs['box_assessment'].classList.add('invalid');
        this.$refs['box_assessment'].classList.add('bottom-invalid');
        document.getElementById('btn_assessment_diagnosa').classList.add('bottom-invalid');
        this.$root.$emit('bv::toggle::collapse', 'accordion_assessment');
      } else {
        document.getElementById('dgKodePenyakit').getElementsByClassName('multiselect__tags')[0].style.removeProperty('border');
        document.getElementById('dgNamaPenyakit').getElementsByClassName('multiselect__tags')[0].style.removeProperty('border');
        this.$refs['box_assessment'].classList.remove('invalid');
        this.$refs['box_assessment'].classList.remove('bottom-invalid');
        document.getElementById('btn_assessment_diagnosa').classList.remove('bottom-invalid');
      }
    },
    checkPemeriksaanFisik() {
      let result = [];
      if (this.formBasicData) {
        let formBasicData = this.formBasicData;
        for (let i in formBasicData) {
          let label = formBasicData[i].label;
          if (label.includes('ket_') && this.postData.hasOwnProperty(label)) {
            let x = label.replace(/ket_/g,'');
            let d = this.postData[x];
            let d_ket = this.postData[label];
            if ((d_ket == '' || d_ket == null || d_ket == undefined || !d_ket) && d) {
              let f = formBasicData.find(f => f.label == label);
              if (x == 'status_psikologis' && d == 'L') {
                f['error'] = true;
              } else if (d == 'Y') {
                f['error'] = true;
              }
            }
          }
        }
        result = formBasicData.filter(item => item.error != null && item.error == true).map(v => v.label);
      }
      this.rekamMedisError.pemeriksaan_fisik = result;
      return result.length > 0;
    },
    setParamsData() {
      this.updatePostDataKlinik([
        { key: 'status_konsultasi', value: this.rmId != null ? 'KONSULTASI' : 'MENUNGGU' },
        { key: 'klinik_id', value: this.getKlinikId },
        { key: 'selesai', value: this.consultation ? 1 : 0 }
      ])
    },
    async updateStatusIfLeave() {
      localStorage.removeItem('poli_id')
      localStorage.removeItem('rekam_medis_id')
      localStorage.removeItem('edit_rekam_medis')
      localStorage.removeItem('rm_reload')
      localStorage.removeItem('edit_rujukan')
      this.$store.commit('rm/RESET_RM')
    },
    updateTerapiObatTouched(value){
      this.terapiObatTouched = value;
    },
    updateTerapiNonObatTouched(value){
      this.terapiNonObatTouched = value;
    },
    updatePostDataRiwayat(val) {
      this.postDataUpdated = val;
    },
    async fetchDataSurveyKepuasan() {
      try {
        const res = await this.$axios.get(
          `/qrcode-kepuasan-pasien/get?klinik_id=${this.getKlinikId}`
        );
        const { status, data } = res.data;
        if (status) {
          const files = data
          this.surveyKepuasan = files[0]
        }
      } catch (e) {
        // console.log(e);
      }
    },
    async donwloadImage(item) {
      const a = document.createElement('a');
        a.href = await this.toDataURL(item.url);
        a.download = item.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },
    toDataURL(url) {
      return fetch(url).then((response) => {
          return response.blob();
      }).then(blob => {
          return URL.createObjectURL(blob);
      });
    },
    readFile(item) {
      window.open(item.url)
    },
  },
};
</script>

<style>
.icon_sync{
	/* width: 17%; */
	width: 60px;
	height: fit-content;
}

.dot {
  margin-right: 8px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
}

.icon {
  color: #cccccc;
}

.grow {
  transition: all 0.2s ease-in-out;
}

.grow:hover {
  transform: scale(1.3);
}

.active_tool {
  color: #464159;
  transform: scale(1.3);
}

.color_active {
  transform: scale(1.3);
}

.active_info {
  color: #3772d7;
  transform: scale(1.3);
}
</style>

<style scoped>
  .btn-show {
    color: #fff;
    background-color: #0d74df;
    border-color: #0d74df;
  }
  .btn-show {
      box-shadow: 0 0.25rem 0.55rem rgba(60, 68, 177, 0.35);
  }
</style>
